import { render, staticRenderFns } from "./addadministratorcc.vue?vue&type=template&id=0f79a8e2&scoped=true&"
import script from "./addadministratorcc.vue?vue&type=script&lang=js&"
export * from "./addadministratorcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f79a8e2",
  null
  
)

export default component.exports